import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { SortingState } from "@tanstack/react-table";

export const PLANNING_SORT_BY_KEY = "planningSort";
export const PLANNING_SORT_DIR_KEY = "planningDir";

const DEFAULT_SORT_COLUMN = "name";
const DEFAULT_SORT_DIRECTION = "asc";

export function usePlanningSortParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const sortBy = searchParams.get(PLANNING_SORT_BY_KEY) ?? DEFAULT_SORT_COLUMN;
  const sortDir =
    searchParams.get(PLANNING_SORT_DIR_KEY) ?? DEFAULT_SORT_DIRECTION;

  const sortingState = useMemo<SortingState>(
    () => [
      {
        id: sortBy,
        desc: sortDir === "desc",
      },
    ],
    [sortBy, sortDir]
  );

  const setSorting = (sorting: SortingState) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      if (sorting.length === 0) {
        newParams.set(PLANNING_SORT_BY_KEY, DEFAULT_SORT_COLUMN);
        newParams.set(PLANNING_SORT_DIR_KEY, DEFAULT_SORT_DIRECTION);
      } else {
        const sort = sorting[0];
        newParams.set(PLANNING_SORT_BY_KEY, sort.id);
        newParams.set(PLANNING_SORT_DIR_KEY, sort.desc ? "desc" : "asc");
      }
      return newParams;
    });
  };

  return {
    sortingState,
    setSorting,
    sortParamKeys: [PLANNING_SORT_BY_KEY, PLANNING_SORT_DIR_KEY],
  };
}
